import React from "react";
import { Differences as DifferencesComponent } from "@italymondo/core-ui";
import { useStaticDifferencesQuery } from "./query";

export function Differences(): React.ReactElement | null {
  const data = useStaticDifferencesQuery();

  if (!data?.aboutPage[0]) {
    return null;
  }

  return (
    <DifferencesComponent
      darkBackground
      description={data?.aboutPage[0].differenceDescription || ""}
      differences={[
        {
          data: data?.aboutPage[0].differences.map((d) => d.difference),
        },
      ]}
      sectionName={data?.aboutPage[0].differenceSectionName || ""}
      title={data?.aboutPage[0].differenceTitle || ""}
    />
  );
}
